export default function CTABannerSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto text-center">
        <div className="rounded-2xl overflow-hidden mb-10 mx-auto max-w-2xl">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20of%20curated%20fashion%20products%20including%20sneakers%20accessories%20and%20leather%20goods%20in%20warm%20earthy%20tones%20on%20cream%20minimal%20surface%20soft%20natural%20lighting%20editorial%20photography%20clean%20harmonious%20composition%20warm%20neutral%20palette%20professional%20catalog%20aesthetic&width=1200&height=500&seq=cta-banner-visual-v2&orientation=landscape"
            alt="OOPBuy Spreadsheet – Jetzt entdecken"
            title="OOPBuy Spreadsheet CTA"
            className="w-full h-full object-cover"
          />
        </div>

        <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-snug max-w-2xl mx-auto mb-6">
          Bereit für <span className="italic font-semibold">tausende Produkte</span> auf <strong>einen Blick</strong>?
        </p>
        <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto mb-8">
          Starte jetzt mit dem OOPBuy Spreadsheet und entdecke eine völlig neue Art des Online-Shoppings. Keine Registrierung erforderlich.
        </p>

        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          Jetzt Spreadsheet öffnen
          <i className="ri-arrow-right-up-line text-sm"></i>
        </a>
      </div>
    </section>
  );
}